var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFireFlinkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7284",
    "data-name": "Group 7284",
    xmlns: "http://www.w3.org/2000/svg",
    width: 182.284,
    height: 37.07,
    viewBox: "0 0 182.284 37.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fireflink_Logo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7277",
    "data-name": "Group 7277",
    transform: "translate(42.042 9.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M50.632,14.493v3.893h7.786v3.893H50.632v6.077H45.6V10.6H59.463v3.893h-8.83Z",
    transform: "translate(-45.6 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M63,10.6h5.032V28.261H63Z",
    transform: "translate(-46.479 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M79.886,23.608H77.132v4.653H72.1V10.6h8.071c4.842,0,7.881,2.469,7.881,6.552a5.9,5.9,0,0,1-3.418,5.6l3.8,5.507H83.114Zm.095-9.115H77.227V19.62h2.754c2.089,0,3.133-.95,3.133-2.564C83.019,15.537,82.07,14.493,79.981,14.493Z",
    transform: "translate(-46.938 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M106.248,24.368v3.893H92.1V10.6h13.863v3.893H97.037v2.943h7.881v3.7H97.037v3.228Z",
    transform: "translate(-47.948 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M115.132,14.493v3.893h7.786v3.893h-7.786v6.077H110.1V10.6h13.863v3.893h-8.83Z",
    transform: "translate(-48.857 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M127.4,10.6h5.032V24.273h8.451v3.988H127.495V10.6Z",
    transform: "translate(-49.73 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M143.9,10.6h5.032V28.261H143.9Z",
    transform: "translate(-50.564 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M169.906,10.6V28.261h-4.083l-7.786-9.4v9.4H153.1V10.6h4.083l7.786,9.4V10.6Z",
    transform: "translate(-51.028 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M181.536,21.9l-1.9,1.994v4.463H174.7V10.6h4.937v7.311l6.836-7.311h5.507l-7.216,7.786,7.6,9.875h-5.792Z",
    transform: "translate(-52.119 -10.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M-1137.483-444.8c-.475.285-.854.475-1.234.665-1.424.76-2.754,1.424-4.178,2.184a.574.574,0,0,0-.285.57v28.77c0,.38-.095.665-.474.76a4.758,4.758,0,0,1-4.368-.38,4.4,4.4,0,0,1-1.8-2.848,25.52,25.52,0,0,1-.285-4.652c-.095-7.6-.19-15.287-.19-22.883a7.274,7.274,0,0,1,.665-3.513,4.252,4.252,0,0,1,5.033-2.279,13.972,13.972,0,0,1,3.8,1.8c1.044.57,2.089,1.139,3.038,1.709C-1137.673-444.991-1137.578-444.9-1137.483-444.8Z",
    transform: "translate(1150.319 448.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M-1136.6-415.177v-8.261a.677.677,0,0,1,.285-.57c3.229-1.8,6.457-3.608,9.59-5.412.854-.475,1.709-.95,2.658-1.519a15.368,15.368,0,0,0-1.709-.949c-1.424-.855-2.849-1.614-4.273-2.469a.424.424,0,0,0-.475,0c-1.8,1.139-3.513,2.184-5.318,3.323-.095,0-.095.095-.19.095v-6.077a.862.862,0,0,1,.285-.665c1.615-1.139,3.228-2.184,4.748-3.323a.606.606,0,0,1,.57,0c2.184,1.234,4.463,2.564,6.646,3.8,1.519.855,3.039,1.709,4.652,2.564a6.738,6.738,0,0,1,2.754,2.659,4.014,4.014,0,0,1-.57,4.653,9.234,9.234,0,0,1-2.658,2.089c-2.184,1.234-4.273,2.564-6.457,3.8-2.754,1.614-5.412,3.133-8.166,4.748C-1135.081-416.127-1135.841-415.652-1136.6-415.177Z",
    transform: "translate(1149.627 448.194)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireFlinkLogo);
export default __webpack_public_path__ + "static/media/FireFlink_logo.b0c536aa1666ff2d9477d9b1fd529ba8.svg";
export { ForwardRef as ReactComponent };